import React from "react";

const KnowledgeInterest = () => {
  const knowledgeContent = [
    {
      id: 1,
      colClass: "left",
      title: "Languages",
      content: [
        " JavaScript",
        " Python",
        " HTML",
        " CSS",
        " MATLAB",
        " LabView",
      ],
    },
    {
      id: 2,
      colClass: "middle",
      title: "Frameworks",
      content: [
        " React",
        " Express",
        " REST API",
        " Bootstrap",
        " Mongoose",
        " Django",
      ],
    },
    {
      id: 3,
      colClass: "right",
      title: "Tools",
      content: [
        "Git",
        "GitHub",
        "Linux",
        "Node.JS",
        "Postman",
        "Visual Studio Code",
        "Mongo Compass",
        "Windows",
      ],
    },
  ];

  return (
    <>
      {knowledgeContent.map((item) => (
        <div className={item.colClass} key={item.id}>
          <div className="tokyo_section_title">
            <h3>{item.title}</h3>
          </div>
          <div className="tokyo_tm_skill_list">
            <ul>
              {item.content.map((val, i) => (
                <li key={i}>
                  <span>
                    <img
                      className="svg"
                      src="assets/img/svg/rightarrow.svg"
                      alt="arrow"
                    />
                    {val}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      ))}
    </>
  );
};

export default KnowledgeInterest;
